export default __webpack_public_path__ + "static/media/Apanio.bfe2ec1f.svg";